import React, { ReactNode, useMemo } from 'react';
import styled from 'styled-components';
import { styled as muiStyled } from '@material-ui/core/styles';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import { DEFAULT_THEME_COLOR } from 'appenv';
import { useSelector } from 'react-redux';

const LoadingIndicatorContainer = styled.div`
  margin: 16px;
  text-align: center;
`;

export type CircularLoadingIndicatorProps = {
  className?: string;
  color?: string;
} & Omit<CircularProgressProps, 'color' | 'className'>;

const CircularLoadingIndicator = React.memo(({
  className,
  color,
  ...indicatorProps
}: CircularLoadingIndicatorProps) => {
  const { themeColor } = useSelector((s: any) => s.eventConfigs);
  const StyledCircularProgress = useMemo(() => muiStyled(CircularProgress)({
    color: color || themeColor || DEFAULT_THEME_COLOR,
  }), [color]);
  return (
    <LoadingIndicatorContainer className={className}>
      <StyledCircularProgress {...indicatorProps} />
    </LoadingIndicatorContainer>
  );
});

export interface CircularLoadingHiderComponentProps {
  condition: boolean;
  children: ReactNode;
}
export const CircularLoadingHiderComponent = ({ condition, children }: CircularLoadingHiderComponentProps) => (
  condition ? (children) : <CircularLoadingIndicator />
);

export default CircularLoadingIndicator;
